module.exports = __webpack_public_path__ + "img/11_85.87fe5254.png";